import { useEffect, useRef, useState } from "react";
import "./CfdTimerSection.css";
import { FaExclamationTriangle } from "react-icons/fa";

const CfdTimerSection = ({ timer }) => {
  // store the end time as a reference that wont change with re-renders
  const endTimeRef = useRef(Date.now() + timer);
  // Convert milliseconds to seconds for initial state
  const [timeLeft, setTimeLeft] = useState(Math.floor(timer / 1000));

  // Update timeLeft when timer prop changes
  useEffect(() => {
    endTimeRef.current = Date.now() + timer;
    setTimeLeft(Math.floor(timer / 1000));
  }, [timer]);

  useEffect(() => {
    if (timeLeft <= 0) return;

    const intervalId = setInterval(() => {
      const secondsLeft = Math.floor((endTimeRef.current - Date.now()) / 1000);
      setTimeLeft(secondsLeft > 0 ? secondsLeft : 0);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [timeLeft]);

  // Convert seconds to time units
  const calculateTimeUnits = (totalSeconds) => {
    if (totalSeconds <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0 };

    const days = Math.floor(totalSeconds / (24 * 60 * 60));
    const hours = Math.floor((totalSeconds % (24 * 60 * 60)) / (60 * 60));
    const minutes = Math.floor((totalSeconds % (60 * 60)) / 60);
    const seconds = totalSeconds % 60;

    return { days, hours, minutes, seconds };
  };

  const timeUnits = calculateTimeUnits(timeLeft);
  // const isTimeLow = timeUnits.days === 0 && timeUnits.hours < 1;
  const isTimeLow = false;
  const isExpired = timeLeft <= 0;

  // Time block component to reduce repetition
  const TimeBlock = ({ value, unit, isLow }) => {
    const singularUnit = value <= 1 ? unit.slice(0, -1) : unit;

    return (
      <div className={`time-block ${isLow ? "time-low" : ""}`}>
        <span className="time-value">{String(value).padStart(2, "0")}</span>
        <span className="time-unit">{singularUnit}</span>
      </div>
    );
  };

  if (isExpired) {
    return (
      // <div className="cfd-header-container expired">
      //   <div className="offer-timer-container">
      //     <div className="offer-timer expired">
      //       <div className="timer-content">
      //         <FaExclamationTriangle className="expired-icon" />
      //         <span className="timer-label">Offer Period Has Ended</span>
      //         <p className="expired-message">
      //           Please check back later for new opportunities
      //         </p>
      //       </div>
      //     </div>
      //   </div>
      // </div>
      null
    );
  }

  return (
    <div className="offer-timer-container">
      <div className="offer-timer">
        <div className="timer-content">
          <span className="timer-label">Offer Period Ends In:</span>
          <div className="timer-display">
            <TimeBlock value={timeUnits.days} unit="Days" isLow={isTimeLow} />
            <div className="time-separator">:</div>
            <TimeBlock value={timeUnits.hours} unit="Hours" isLow={isTimeLow} />
            <div className="time-separator">:</div>
            <TimeBlock
              value={timeUnits.minutes}
              unit="Minutes"
              isLow={isTimeLow}
            />
            <div className="time-separator">:</div>
            <TimeBlock
              value={timeUnits.seconds}
              unit="Seconds"
              isLow={isTimeLow}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CfdTimerSection;
